export enum AuthActionType {
	LOGIN_REQUEST = 'LOGIN_REQUEST',
	LOGIN_SUCCESS = 'LOGIN_SUCCESS',
	LOGIN_FAILED = 'LOGIN_FAILED',

	LOGOUT_REQUEST = 'LOGOUT_REQUEST',
	LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
	LOGOUT_FAILED = 'LOGOUT_FAILED',

	SIGNUP_REQUEST = 'SIGNUP_REQUEST',
	SIGNUP_SUCCESS = 'SIGNUP_SUCCESS',
	SIGNUP_FAILED = 'SIGNUP_FAILED',

	PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST',
	PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS',
	PASSWORD_RESET_FAILED = 'PASSWORD_RESET_FAILED',

	SET_LOCALE_REQUEST = 'SET_LOCALE_REQUEST',
	SET_LOCALE_FAILED = 'SET_LOCALE_FAILED',
	SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS',

	RESET_AUTH = 'RESET_AUTH',

	SEND_OTP = 'SEND_OTP',
	SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS',
	SEND_OTP_FAILED = 'SEND_OTP_FAILED',
	RESEND_OTP = 'RESEND_OTP',

	VERIFY_OTP = 'VERIFY_OTP',
	VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS',
	VERIFY_OTP_FAILED = 'VERIFY_OTP_FAILED'
}
